import type { PropsWithChildren } from 'react';
import React from 'react';

import st from './ResultSectionPanel.module.sass';

interface ResultSectionPanelProps extends PropsWithChildren {
  title: string;
  subtitle?: React.ReactNode;
}

export function ResultSectionPanel({
  title,
  subtitle = undefined,
  children = undefined,
}: ResultSectionPanelProps): React.JSX.Element {
  return (
    <div className={st.Root}>
      <div className={st.Title}>
        {title}
        {subtitle}
      </div>
      {!!children && (
        <div className={st.Content}>
          {children}
        </div>
      )}
    </div>
  );
}
